"use client";

import dynamic from "next/dynamic";
import VadImage from "vadimages-nextjs-image-optimizer";
const ContactForm = dynamic(() => import("@/app/parts/global/ContactForm"));
import form from "@/styles/modules/sample_form.module.scss";
import contactForm from "@/styles/modules/contactform.module.scss";
import * as Api from "@api";

const PageKeys = ["button"] as const;

interface SingularFormProps {
  formContent: Api.Content<(typeof PageKeys)[number]>;
  onUnboundaryTouch?: (e: React.MouseEvent<HTMLElement>) => void;
}

const SingularForm = ({
  formContent,
  onUnboundaryTouch,
}: SingularFormProps) => {
  return (
    <section
      id="contact-us"
      className="py-10 md:py-0"
      onClick={onUnboundaryTouch ? onUnboundaryTouch : () => {}}
    >
      <div className="container">
        <div className="relative rounded-default overflow-hidden px-6 py-10 md:py-10 md:px-12 lg:py-20 lg:px-28">
          <div className="relative w-full z-10">
            <div className="md:absolute h-full flex flex-col-reverse md:flex-col justify-between">
              <div className="text-white md:max-w-[350px] lg:max-w-[420px] max-md:text-center max-md:mx-auto">
                <h2 className="mb-5 max-lg:text-5xl">
                  Get started with Singular
                </h2>
                <p className="mb-12">
                  Test your brand’s extracts with Singular. Samples delivered in
                  2-7 days.
                </p>
              </div>
              <div className="md:max-w-[555px]">
                <VadImage
                  src="/images/singular/samples-header.png"
                  alt="Get started with Singular"
                  width={528}
                  height={528}
                  className="-translate-x-[30px] md:-translate-x-[125px] lg:-translate-x-[75px]"
                />
              </div>
            </div>

            <div className="w-full flex justify-end">
              <div className="max-w-full md:max-w-[40%]">
                <div className={`${contactForm.zoho_form_wrapper} !px-0`}>
                  <ContactForm
                    pageContent={formContent}
                    checkboxLabelClassName="!text-white"
                    source={'singular'}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="absolute w-full h-full left-0 top-0">
            <VadImage
              src={`/images/singular/gradient.png`}
              alt="Background"
              width={1600}
              height={1600}
              className="pointer-events-none absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SingularForm;
